import React, { useState } from 'react'
import { cn, getUserType } from '@utils/safeTs'
import styles from './MyAccountArticoliOrdine.module.sass'
import { RigaOrdinePersonalizzazioneType, RigaOrdineType, RootStateType, UserType } from '@utils/types'
import { useSelector } from 'react-redux'
import useTrans from '@hooks/useTrans'
import MyAccountArticoloOrdine from '../MyAccountArticoloOrdine/MyAccountArticoloOrdine'
import DatatableOrdiniDetail from '../DatatableOrdiniDetail/DatatableOrdiniDetail'
import MyAccountOrdineSectionHead from '@components/atoms/MyAccountOrdineSectionHead/MyAccountOrdineSectionHead'
import { ChevronDown } from '@components/icons'


interface Props {
  righeOrdine?: (RigaOrdinePersonalizzazioneType & RigaOrdineType)[]
  variant?: 'default' | 'onlyProducts'
  noteStyle?: 'default' | 'accent'
  noteFornitore?: string
  collapsible?: boolean
  note?: boolean
  userType?: UserType
}

const MyAccountArticoliOrdine = (props: Props) => {

  const { 
    righeOrdine = [],
    variant = 'default',
    noteStyle = 'default',
    noteFornitore,
    collapsible = false,
    note = false,
    userType,
  } = props

  const t = useTrans()
  const [open, setOpen] = useState(true)

  return righeOrdine?.length ? (
    (userType !== 'cliente') || (variant === 'onlyProducts') ? ( // Solo il cliente vede i prezzi, gli altri versione compatta dei prodotti + eventuali note se è una personalizzazione
      <>
        <section className={styles.section}>
          {collapsible ? (
            <button type="button" className={styles.trigger} onClick={() => setOpen(prev => !prev)}>
              <span>{t('Prodotti')}</span>
              <ChevronDown />
            </button>
          ) : (
            <MyAccountOrdineSectionHead title={t("Prodotti")} userType={userType} />
          )}
          {open && (
            <>
              <div className={styles.list}>
                {righeOrdine.map((riga) => (
                  <MyAccountArticoloOrdine 
                    key={riga.id} 
                    articolo={riga.articolo} 
                    quantita={riga.quantita}
                    variant={variant}
                  />
                ))}
              </div>
                {note && !!righeOrdine.map(r => r.nota).filter(Boolean)?.length ? (
                  <section className={cn(styles.note, styles[`note--${noteStyle}`])}>
                    <div className={styles.noteContent}>
                      <p className={styles.noteTitle}>{t('Note riga prodotto:')}</p>
                      <div className={styles.noteValue}>
                        {righeOrdine.map(r => r.nota).filter(Boolean).map(x => (
                          <p>{x}</p>
                        ))}
                      </div>
                    </div>
                  </section>
                ) : null}
                {noteFornitore && userType !== 'cliente' ? (
                  <section className={cn(styles.note, styles[`note--warning`])}>
                    <div className={styles.noteContent}>
                      <p className={styles.noteTitle}>{t('Note interne per fornitore:')}</p>
                      <div className={styles.noteValue}>
                        {noteFornitore?.toLocaleLowerCase()}
                      </div>
                    </div>
                  </section>
                ) : null}
            </>
          )}
        </section>
      </>
    ) : (
      // altrimenti versione full dei prodotti con tutti i prezzi del cliente finale
      <DatatableOrdiniDetail righeOrdine={righeOrdine} userType={userType} />
    )
  ) : <></>
}

export default MyAccountArticoliOrdine
